import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import toast from "react-hot-toast";
import { supabase } from "../../lib/supabase";
import { invalidateSharingQueries } from "../../lib/invalidateSharing";
import { useAuth } from "../../contexts/AuthContext";

// Leave (CONTEXT.md): a Member ending their own membership. The Shared
// list disappears from their board; everybody else keeps it, and the Tasks
// they wrote stay behind (they just stop being a Member's Tasks to edit).
export function useLeaveList() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: async (listId: string): Promise<void> => {
      if (!user) throw new Error("Not authenticated");
      const { error } = await supabase
        .from("list_members")
        .delete()
        .eq("list_id", listId)
        .eq("user_id", user.id);
      if (error) throw error;
    },

    onSuccess: (_result, listId) => {
      invalidateSharingQueries(queryClient, listId);
    },

    onError: (err) => {
      Sentry.captureException(err, { extra: { mutation: "useLeaveList" } });
      toast.error("Couldn't leave that list. Please try again.");
    },
  });
}
